import script from "./PaymentSelectionItem.vue?vue&type=script&lang=ts&setup=true&async=true"
export * from "./PaymentSelectionItem.vue?vue&type=script&lang=ts&setup=true&async=true"

const __exports__ = script;

export default __exports__